// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../../shared/src/Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Apollo = require("../../../shared/src/bindings/Apollo.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var CommonTypes_Jwt = require("../../../shared/src/types/CommonTypes_Jwt.bs.js");
var CommonTypes_Guid = require("../../../shared/src/types/CommonTypes_Guid.bs.js");
var CommonTypes_Email = require("../../../shared/src/types/CommonTypes_Email.bs.js");

var Raw = {};

var query = "mutation signinWithEmail($email: String!, $password: String!)  {\nsigninWithEmail(input: {email: $email, password: $password})  {\njwt  \n}\n\n}\n";

function parse(value) {
  var value$1 = value.signinWithEmail;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.jwt;
    tmp = {
      jwt: !(value$2 == null) ? Caml_option.some(CommonTypes_Jwt.GraphQL_API.parse(value$2)) : undefined
    };
  }
  return {
          signinWithEmail: tmp
        };
}

function serialize(value) {
  var value$1 = value.signinWithEmail;
  var signinWithEmail;
  if (value$1 !== undefined) {
    var value$2 = value$1.jwt;
    var jwt = value$2 !== undefined ? Curry._1(CommonTypes_Jwt.GraphQL_API.serialize, Caml_option.valFromOption(value$2)) : null;
    signinWithEmail = {
      jwt: jwt
    };
  } else {
    signinWithEmail = null;
  }
  return {
          signinWithEmail: signinWithEmail
        };
}

function serializeVariables(inp) {
  return {
          email: inp.email,
          password: inp.password
        };
}

function makeVariables(email, password, param) {
  return {
          email: email,
          password: password
        };
}

function variables(param) {
  return Json.Encode.object_({
              hd: [
                "email",
                Curry._1(CommonTypes_Email.encode, param.email)
              ],
              tl: {
                hd: [
                  "password",
                  param.password
                ],
                tl: /* [] */0
              }
            });
}

function decode(param) {
  var match = param.signinWithEmail;
  if (match !== undefined) {
    return match.jwt;
  }
  
}

var Definition = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  variables: variables,
  decode: decode
};

var include = Apollo.CreateMutation({
      Raw: Raw,
      query: query,
      variables: variables,
      parse: parse,
      decode: decode
    });

var Business_graphqlMutationAST = include.graphqlMutationAST;

var Business_mutate = include.mutate;

var Business_mutateStoreError = include.mutateStoreError;

var Business_mutateResult = include.mutateResult;

var Business_mutateResultStore = include.mutateResultStore;

var Business_mutateAsyncData = include.mutateAsyncData;

var Business_mutateAsyncResult = include.mutateAsyncResult;

var Business_mutateAsycResultApolloError = include.mutateAsycResultApolloError;

var Business = {
  Definition: Definition,
  graphqlMutationAST: Business_graphqlMutationAST,
  mutate: Business_mutate,
  mutateStoreError: Business_mutateStoreError,
  mutateResult: Business_mutateResult,
  mutateResultStore: Business_mutateResultStore,
  mutateAsyncData: Business_mutateAsyncData,
  mutateAsyncResult: Business_mutateAsyncResult,
  mutateAsycResultApolloError: Business_mutateAsycResultApolloError
};

var Raw$1 = {};

var query$1 = "mutation sendPasswordResetEmail($email: String!)  {\nsendPasswordResetEmail(input: {email: $email})  {\nsuccess  \n}\n\n}\n";

function parse$1(value) {
  var value$1 = value.sendPasswordResetEmail;
  return {
          sendPasswordResetEmail: !(value$1 == null) ? ({
                success: value$1.success
              }) : undefined
        };
}

function serialize$1(value) {
  var value$1 = value.sendPasswordResetEmail;
  var sendPasswordResetEmail;
  if (value$1 !== undefined) {
    var value$2 = value$1.success;
    sendPasswordResetEmail = {
      success: value$2
    };
  } else {
    sendPasswordResetEmail = null;
  }
  return {
          sendPasswordResetEmail: sendPasswordResetEmail
        };
}

function serializeVariables$1(inp) {
  return {
          email: inp.email
        };
}

function makeVariables$1(email, param) {
  return {
          email: email
        };
}

function variables$1(email) {
  return Json.Encode.object_({
              hd: [
                "email",
                Curry._1(CommonTypes_Email.encode, email)
              ],
              tl: /* [] */0
            });
}

function decode$1(param) {
  return Relude_Option.pure(undefined);
}

var Definition$1 = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  variables: variables$1,
  decode: decode$1
};

var include$1 = Apollo.CreateMutation({
      Raw: Raw$1,
      query: query$1,
      variables: variables$1,
      parse: parse$1,
      decode: decode$1
    });

var SendPasswordResetEmail_graphqlMutationAST = include$1.graphqlMutationAST;

var SendPasswordResetEmail_mutate = include$1.mutate;

var SendPasswordResetEmail_mutateStoreError = include$1.mutateStoreError;

var SendPasswordResetEmail_mutateResult = include$1.mutateResult;

var SendPasswordResetEmail_mutateResultStore = include$1.mutateResultStore;

var SendPasswordResetEmail_mutateAsyncData = include$1.mutateAsyncData;

var SendPasswordResetEmail_mutateAsyncResult = include$1.mutateAsyncResult;

var SendPasswordResetEmail_mutateAsycResultApolloError = include$1.mutateAsycResultApolloError;

var SendPasswordResetEmail = {
  Definition: Definition$1,
  graphqlMutationAST: SendPasswordResetEmail_graphqlMutationAST,
  mutate: SendPasswordResetEmail_mutate,
  mutateStoreError: SendPasswordResetEmail_mutateStoreError,
  mutateResult: SendPasswordResetEmail_mutateResult,
  mutateResultStore: SendPasswordResetEmail_mutateResultStore,
  mutateAsyncData: SendPasswordResetEmail_mutateAsyncData,
  mutateAsyncResult: SendPasswordResetEmail_mutateAsyncResult,
  mutateAsycResultApolloError: SendPasswordResetEmail_mutateAsycResultApolloError
};

var Raw$2 = {};

var query$2 = "mutation getUserByPasswordResetToken($token: String!)  {\ngetUserByPasswordResetToken(input: {token: $token})  {\nisValid  \n}\n\n}\n";

function parse$2(value) {
  var value$1 = value.getUserByPasswordResetToken;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.isValid;
    tmp = {
      isValid: !(value$2 == null) ? value$2 : undefined
    };
  }
  return {
          getUserByPasswordResetToken: tmp
        };
}

function serialize$2(value) {
  var value$1 = value.getUserByPasswordResetToken;
  var getUserByPasswordResetToken;
  if (value$1 !== undefined) {
    var value$2 = value$1.isValid;
    var isValid = value$2 !== undefined ? value$2 : null;
    getUserByPasswordResetToken = {
      isValid: isValid
    };
  } else {
    getUserByPasswordResetToken = null;
  }
  return {
          getUserByPasswordResetToken: getUserByPasswordResetToken
        };
}

function serializeVariables$2(inp) {
  return {
          token: inp.token
        };
}

function makeVariables$2(token, param) {
  return {
          token: token
        };
}

function variables$2(token) {
  return Json.Encode.object_({
              hd: [
                "token",
                CommonTypes_Guid.encode(token)
              ],
              tl: /* [] */0
            });
}

function decode$2(param) {
  return Relude_Option.pure(undefined);
}

var Definition$2 = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  variables: variables$2,
  decode: decode$2
};

var include$2 = Apollo.CreateMutation({
      Raw: Raw$2,
      query: query$2,
      variables: variables$2,
      parse: parse$2,
      decode: decode$2
    });

var ValidateResetToken_graphqlMutationAST = include$2.graphqlMutationAST;

var ValidateResetToken_mutate = include$2.mutate;

var ValidateResetToken_mutateStoreError = include$2.mutateStoreError;

var ValidateResetToken_mutateResult = include$2.mutateResult;

var ValidateResetToken_mutateResultStore = include$2.mutateResultStore;

var ValidateResetToken_mutateAsyncData = include$2.mutateAsyncData;

var ValidateResetToken_mutateAsyncResult = include$2.mutateAsyncResult;

var ValidateResetToken_mutateAsycResultApolloError = include$2.mutateAsycResultApolloError;

var ValidateResetToken = {
  Definition: Definition$2,
  graphqlMutationAST: ValidateResetToken_graphqlMutationAST,
  mutate: ValidateResetToken_mutate,
  mutateStoreError: ValidateResetToken_mutateStoreError,
  mutateResult: ValidateResetToken_mutateResult,
  mutateResultStore: ValidateResetToken_mutateResultStore,
  mutateAsyncData: ValidateResetToken_mutateAsyncData,
  mutateAsyncResult: ValidateResetToken_mutateAsyncResult,
  mutateAsycResultApolloError: ValidateResetToken_mutateAsycResultApolloError
};

var Raw$3 = {};

var query$3 = "mutation setNewPassword($newPassword: String!, $token: String!)  {\nsetNewPassword(input: {token: $token, newPassword: $newPassword})  {\nclientMutationId  \n}\n\n}\n";

function parse$3(value) {
  var value$1 = value.setNewPassword;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.clientMutationId;
    tmp = {
      clientMutationId: !(value$2 == null) ? value$2 : undefined
    };
  }
  return {
          setNewPassword: tmp
        };
}

function serialize$3(value) {
  var value$1 = value.setNewPassword;
  var setNewPassword;
  if (value$1 !== undefined) {
    var value$2 = value$1.clientMutationId;
    var clientMutationId = value$2 !== undefined ? value$2 : null;
    setNewPassword = {
      clientMutationId: clientMutationId
    };
  } else {
    setNewPassword = null;
  }
  return {
          setNewPassword: setNewPassword
        };
}

function serializeVariables$3(inp) {
  return {
          newPassword: inp.newPassword,
          token: inp.token
        };
}

function makeVariables$3(newPassword, token, param) {
  return {
          newPassword: newPassword,
          token: token
        };
}

function variables$3(param) {
  return Json.Encode.object_({
              hd: [
                "newPassword",
                param.password
              ],
              tl: {
                hd: [
                  "token",
                  CommonTypes_Guid.encode(param.token)
                ],
                tl: /* [] */0
              }
            });
}

function decode$3(param) {
  return Relude_Option.pure(undefined);
}

var Definition$3 = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  variables: variables$3,
  decode: decode$3
};

var include$3 = Apollo.CreateMutation({
      Raw: Raw$3,
      query: query$3,
      variables: variables$3,
      parse: parse$3,
      decode: decode$3
    });

var ResetPassword_graphqlMutationAST = include$3.graphqlMutationAST;

var ResetPassword_mutate = include$3.mutate;

var ResetPassword_mutateStoreError = include$3.mutateStoreError;

var ResetPassword_mutateResult = include$3.mutateResult;

var ResetPassword_mutateResultStore = include$3.mutateResultStore;

var ResetPassword_mutateAsyncData = include$3.mutateAsyncData;

var ResetPassword_mutateAsyncResult = include$3.mutateAsyncResult;

var ResetPassword_mutateAsycResultApolloError = include$3.mutateAsycResultApolloError;

var ResetPassword = {
  Definition: Definition$3,
  graphqlMutationAST: ResetPassword_graphqlMutationAST,
  mutate: ResetPassword_mutate,
  mutateStoreError: ResetPassword_mutateStoreError,
  mutateResult: ResetPassword_mutateResult,
  mutateResultStore: ResetPassword_mutateResultStore,
  mutateAsyncData: ResetPassword_mutateAsyncData,
  mutateAsyncResult: ResetPassword_mutateAsyncResult,
  mutateAsycResultApolloError: ResetPassword_mutateAsycResultApolloError
};

exports.Business = Business;
exports.SendPasswordResetEmail = SendPasswordResetEmail;
exports.ValidateResetToken = ValidateResetToken;
exports.ResetPassword = ResetPassword;
/* include Not a pure module */
